import { useQuery } from '@tanstack/react-query'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { postNamedQuery } from '../../../../../service'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import { useSeCodes } from './SeDebugContext'

export default function useSfClientTasks (isClosed) {
  const { clientId } = useAppContext()
  const codes = useSeCodes()

  const query = useQuery({
    queryKey: [QUERY_KEYS.woSfTasks, clientId, codes.list, isClosed ?? null],
    queryFn: async () => {
      const variables = { clientId }
      if (isClosed != null) {
        variables.isClosed = isClosed
      }
      const { data } = await postNamedQuery('coreData', 'invoke-smart-endpoint', {
        pipelineCode: codes.list,
        variables
      })
      return data
    },
    enabled: !!clientId
  })

  const tasks = query.data?.tasks ?? []
  const notLinked = query.data?.notLinked === true

  return {
    tasks,
    notLinked,
    isLoading: query.isLoading,
    error: query.error
  }
}
